/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Response from deleting an extraction schema.
 */
export type SchemaDeleteResponse = {
  /**
   * Indicates whether the schema deletion was successful
   */
  success: boolean;
  /**
   * A confirmation message about the deletion
   */
  message: string;
};

/** @internal */
export const SchemaDeleteResponse$inboundSchema: z.ZodType<
  SchemaDeleteResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  success: z.boolean(),
  message: z.string(),
});
/** @internal */
export type SchemaDeleteResponse$Outbound = {
  success: boolean;
  message: string;
};

/** @internal */
export const SchemaDeleteResponse$outboundSchema: z.ZodType<
  SchemaDeleteResponse$Outbound,
  z.ZodTypeDef,
  SchemaDeleteResponse
> = z.object({
  success: z.boolean(),
  message: z.string(),
});

export function schemaDeleteResponseToJSON(
  schemaDeleteResponse: SchemaDeleteResponse,
): string {
  return JSON.stringify(
    SchemaDeleteResponse$outboundSchema.parse(schemaDeleteResponse),
  );
}
export function schemaDeleteResponseFromJSON(
  jsonString: string,
): SafeParseResult<SchemaDeleteResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SchemaDeleteResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SchemaDeleteResponse' from JSON`,
  );
}
